// extracted by mini-css-extract-plugin
var _1 = "HistoryIcon__bonusImg--hWHzk";
var _2 = "HistoryIcon__celImg--MpyV1";
var _3 = "HistoryIcon__celestial--aiz6v";
var _4 = "HistoryIcon__clickable--FNFj8";
var _5 = "HistoryIcon__empty--pglJn";
var _6 = "HistoryIcon__iconContainer--ejS2G";
var _7 = "HistoryIcon__intervened--zmAPL";
var _8 = "HistoryIcon__main--ghoYI";
var _9 = "HistoryIcon__mainStars--akQGf HistoryIcon__main--ghoYI";
var _a = "HistoryIcon__partial--lphMD";
var _b = "HistoryIcon__stars--Dn4Cq";
var _c = "HistoryIcon__starsImg--p6u2A";
var _d = "HistoryIcon__starsOnly--g2wf9 HistoryIcon__stars--Dn4Cq";
var _e = "HistoryIcon__trophyImg--VNlTL";
export { _1 as "bonusImg", _2 as "celImg", _3 as "celestial", _4 as "clickable", _5 as "empty", _6 as "iconContainer", _7 as "intervened", _8 as "main", _9 as "mainStars", _a as "partial", _b as "stars", _c as "starsImg", _d as "starsOnly", _e as "trophyImg" }
